import { Integration } from "src/app/backend/models/integration";

export enum InstallationStatus {
  ENABLED = "enabled",
  DISABLED = "disabled",
  PENDING_ACTIVATION = "pending-activation"
}
export interface Installation {
  id: string;
  status: InstallationStatus;
  integrationId: string;
  createdBy: {
    id: string;
    name: string;
  };
  configuration?: Record<string, string | number | boolean>;
}

export type InstallationInstalled = Installation & {
  integration: Integration;
};

export interface InstallationCommand {
  id: string;
  action: string;
  body: string;
  createdAt: string;
  installationId: string;
  updatedAt: string;
  requestedBy: {
    id: string;
    name: string;
  };
  requestedAt: string;
}

type InstallationCreateConnectionNoneArgs = {
  provider: string;
  type: "none";
  default: boolean;
  installationId: string;
};

type InstallationCreateConnectionBasicArgs = {
  provider: string;
  type: "basic";
  credentials: InstallationCreateConnectionBasicCredentials;
  default: boolean;
  installationId: string;
};

type InstallationCreateConnectionOAuthArgs = {
  provider: string;
  type: "oauth2";
  credentials: InstallationCreateConnectionOAuthCredentials;
  default: boolean;
  installationId: string;
};

type InstallationCreateConnectionCustomArgs = {
  provider: string;
  type: "custom";
  credentials: InstallationCreateConnectionCustomCredentials;
  default: boolean;
  installationId: string;
};

export type InstallationCreateConnectionArgs =
  | InstallationCreateConnectionNoneArgs
  | InstallationCreateConnectionBasicArgs
  | InstallationCreateConnectionOAuthArgs
  | InstallationCreateConnectionCustomArgs;

type InstallationUpdateConnectionBasicArgs = {
  connectionId: string;
  type: "basic";
  credentials: InstallationCreateConnectionBasicCredentials;
  version: number;
};

type InstallationUpdateConnectionOAuthArgs = {
  connectionId: string;
  type: "oauth2";
  credentials: InstallationCreateConnectionOAuthCredentials;
  version: number;
};

type InstallationUpdateConnectionCustomArgs = {
  connectionId: string;
  type: "custom";
  credentials: InstallationCreateConnectionCustomCredentials;
  version: number;
};

type InstallationUpdateConnectionNoneArgs = {
  connectionId: string;
  type: "none";
  version: number;
  credentials: undefined;
};

export type InstallationUpdateConnectionArgs =
  | InstallationUpdateConnectionNoneArgs
  | InstallationUpdateConnectionBasicArgs
  | InstallationUpdateConnectionOAuthArgs
  | InstallationUpdateConnectionCustomArgs;

type InstallationCreateConnectionBasicCredentials = {
  username: string;
  password: string;
};

type InstallationCreateConnectionOAuthCredentials = {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
};

type InstallationCreateConnectionCustomCredentials = Record<string, any>;

export type InstallationRedeemedCredentials =
  InstallationCreateConnectionOAuthCredentials;
